import axios from "axios";
import { BE_SERVER_ENDPOINT, API_PROTOCOL } from "../constants/configs.js";
import { PRODUCT_TYPE_CONFIG, COLOR_PALETTE_TYPE, GLOBAL_EVENTS } from "../constants/common";
import { CONFIG_FETCHER_ACTIONS } from "../actions/configFetcherActions";
import { filterAndSetInMemConfigs } from "../helpers/helper.js";

const ConfigDataFetcher = {
    fetchConfigData: function (options) {
        let configType = options.configType ? options.configType : PRODUCT_TYPE_CONFIG.WEB;
        return dispatch => {
            let url = `${API_PROTOCOL}${BE_SERVER_ENDPOINT}/v2.0/`;
            if (options.isPublic) {
                url += 'public/';
            }
            url += `configs/${configType}/pilot/${options.pilotId}`;

            axios.get(url, {
                handlerEnabled: !options.isPublic
            }).then(response => {
                filterAndSetInMemConfigs(response.data.payload);
                dispatch({
                    type: CONFIG_FETCHER_ACTIONS.FETCH_CONFIG_DATA_SUCCESS,
                    payload: response.data.payload
                });
            }).catch(error => {
                dispatch({
                    type: CONFIG_FETCHER_ACTIONS.FETCH_CONFIG_DATA_ERROR,
                    payload: error
                });
            });
        };
    },
    fetchColorPaletteData: (options) => {
        const defaultPalette = COLOR_PALETTE_TYPE.WEB;
        return dispatch => {
            let url = `${API_PROTOCOL}${BE_SERVER_ENDPOINT}/v2.0/`;
            if (options.isPublic) {
                url += 'public/';
            }
            url += `configs/${defaultPalette}/pilot/${options.pilotId}`;

            axios.get(url, {
                handlerEnabled: !options.isPublic
            }).then(response => {
                dispatch({
                    type: CONFIG_FETCHER_ACTIONS.FETCH_COLOR_PALETTE_DATA_SUCCESS,
                    payload: {
                        paletteType: options.paletteType ? options.paletteType : defaultPalette,
                        data: response.data.payload
                    }
                });
            }).catch(error => {
                dispatch({
                    type: CONFIG_FETCHER_ACTIONS.FETCH_COLOR_PALETTE_DATA_ERROR,
                    payload: error
                });
            });
        }
    },
    fetchLanguagePreference: (uuid) => {
        let url = `${API_PROTOCOL}${BE_SERVER_ENDPOINT}/v2.0/dashboard/users/${uuid}/language-preferences`;
        return dispatch => {
            axios.get(url, {
                params: {
                    templateName: GLOBAL_EVENTS.FETCH_LANGUAGE_PREFERENCES
                }
            }).then(response => {
                dispatch({
                    type : CONFIG_FETCHER_ACTIONS.FETCH_LANGUAGE_PREFERENCES,
                    payload: response.data.payload
                })
            })
        }
    },
    fetchUserType: (uuid, mType) => {
        let url = `${API_PROTOCOL}${BE_SERVER_ENDPOINT}/meta/users/${uuid}/usertype`;
        return dispatch => {
            axios.get(url, {
                params: {
                    mType,
                    templateName: GLOBAL_EVENTS.FETCH_USER_TYPE
                }
            }).then(response => {
                dispatch({
                    type: CONFIG_FETCHER_ACTIONS.FETCH_USER_TYPE_SUCCESS,
                    payload: response.data
                })
            }).catch(error => {
                dispatch({
                    type: CONFIG_FETCHER_ACTIONS.FETCH_USER_TYPE_ERROR
                })
            })
        }
    }
};

export default ConfigDataFetcher;
